import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DOCUMENTS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={DOCUMENTS} id={id} />;
}

export const Route = createFileRoute("/_app/documents/$id")({
  component: Edit,
});
